import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboardIcon, TagsIcon, UsersIcon, ClipboardCheckIcon, GitCompareIcon, FileTextIcon } from 'lucide-react';
import { colors } from '../utils/colors';
const Navigation = () => {
  const navItems = [{
    path: '/',
    label: 'Overview',
    icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-62" />
  }, {
    path: '/thematic-analysis',
    label: 'Thematic Analysis',
    icon: <TagsIcon className="w-5 h-5" data-id="element-63" />
  }, {
    path: '/stakeholders-geography',
    label: 'Stakeholders & Geography',
    icon: <UsersIcon className="w-5 h-5" data-id="element-64" />
  }, {
    path: '/evidence-review',
    label: 'Evidence Review',
    icon: <ClipboardCheckIcon className="w-5 h-5" data-id="element-65" />
  }, {
    path: '/position-mapping',
    label: 'Position Mapping',
    icon: <GitCompareIcon className="w-5 h-5" data-id="element-66" />
  }, {
    path: '/individual-submissions',
    label: 'Individual Submissions',
    icon: <FileTextIcon className="w-5 h-5" data-id="element-67" />
  }];
  return <nav className="bg-white border-b border-gray-200" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex space-x-4 overflow-x-auto" data-id="element-70">
          {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
          isActive
        }) => `flex items-center px-3 py-2 text-sm font-medium ${isActive ? `border-b-2 border-[${colors.primary.medium}] text-[${colors.primary.dark}]` : 'text-gray-500 hover:text-gray-700 hover:border-b-2 hover:border-gray-300'}`} style={({
          isActive
        }) => ({
          borderColor: isActive ? colors.primary.medium : '',
          color: isActive ? colors.primary.dark : ''
        })} data-id="element-71">
              <span className="mr-2" data-id="element-72">{item.icon}</span>
              <span data-id="element-73">{item.label}</span>
            </NavLink>)}
        </div>
      </div>
    </nav>;
};
export default Navigation;